import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function FinalCTASection() {
  return (
    <section className="py-32 px-6 lg:px-12 bg-gradient-to-b from-card to-black">
      <div className="max-w-[1200px] mx-auto text-center">
        {/* Main Content */}
        <div className="glass-card p-12 md:p-16 lg:p-20 rounded-[48px] border-2 border-primary/20">
          {/* Icon */}
          <div className="w-20 h-20 rounded-full bg-primary/10 border-2 border-primary flex items-center justify-center mx-auto mb-8 animate-pulse-glow">
            <Icon name="ShieldCheckIcon" size={40} variant="solid" className="text-primary" />
          </div>

          {/* Headline */}
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mb-6 tracking-tight">
            ¿LISTO PARA PROTEGER
            <br />
            <span className="text-gradient-red">TU INVERSIÓN?</span>
          </h2>

          {/* Description */}
          <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto mb-12 leading-relaxed">
            Agenda tu consulta gratuita y descubre cómo podemos proteger tu vehículo con tecnología de nivel competición
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Link
              href="/contact"
              className="flex items-center gap-3 bg-primary hover:bg-primary/90 text-white px-12 py-5 rounded-full font-heading text-sm tracking-wider transition-all duration-300 hover:scale-105 animate-pulse-glow"
            >
              AGENDAR CONSULTA GRATIS
              <Icon name="CalendarIcon" size={20} variant="outline" />
            </Link>
            <a
              href="https://wa.link/4exlpx"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 text-white px-12 py-5 rounded-full font-heading text-sm tracking-wider transition-all duration-300 hover:scale-105"
            >
              WHATSAPP DIRECTO
              <Icon name="ChatBubbleLeftRightIcon" size={20} variant="outline" />
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-12 pt-12 border-t border-white/10">
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <Icon name="CheckCircleIcon" size={20} variant="solid" className="text-primary" />
              <span>Garantía 10 años</span>
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <Icon name="ClockIcon" size={20} variant="outline" className="text-primary" />
              <span>Respuesta en 24h</span>
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <Icon name="ShieldCheckIcon" size={20} variant="solid" className="text-primary" />
              <span>Certificación oficial</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}